import { NgModule } from '@angular/core';
import { FuiSelectService } from '@services/fui-components/select.service';

/**
 * Если нужна дополнительная инициализация для вспомогательных сервисов по работе с библиотекой F-UI Components,
 * её лучше делать централизованно тут.
 */
@NgModule({
    providers: [FuiSelectService],
})
export class FuiComponentsModule {}
